import { 
    // 收支統計
    apiBizGetFinancialIncome,
    // 收入排名
    apiBizGetFinancialRanking,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_report_over_view_income: 'reportOverView/set_report_over_view_income',
    set_report_over_view_ranking: 'reportOverView/set_report_over_view_ranking',
    set_report_over_view_group_name: 'reportOverView/set_report_over_view_group_name',

}

// count state 必須是 Object
const state = {
    incomeList: [],
    rankingList: [],
    groupName: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_REPORT_OVER_VIEW_INCOME_LIST: (state) => {
        return state.incomeList
    },
    GET_BIZ_REPORT_OVER_VIEW_RANKING_LIST: (state) => {
        return state.rankingList
    },
    GET_BIZ_REPORT_OVER_VIEW_GROUP_NAME: (state) => {
        return state.groupName
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizReportOverViewRankingList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetFinancialRanking(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_report_over_view_ranking, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getBizReportOverViewIncomeList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetFinancialIncome(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_report_over_view_income, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setGroupName ( {commit}, data ) {
        commit(types.set_report_over_view_group_name, data);
    }
}

// mutations
const mutations = {
    [types.set_report_over_view_income](state, data){
        state.incomeList = data
    },
    [types.set_report_over_view_ranking](state, data){
        state.rankingList = data
    },
    [types.set_report_over_view_group_name](state, data){
        state.groupName = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/reportOverView.js